import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">编辑推荐的优质内容，每篇都值得细细品读</p>
          </div>
          <Link
            to="/category/newlywed-guide"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.id} {...article} variant="default" />
          ))}
        </div>

        <div className="mt-8 flex justify-center sm:hidden">
          <Link
            to="/category/newlywed-guide"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}